import React, { useEffect, useRef, useState } from "react";
import '../../assets/scss/dropdown.scss';


export type DropdownAction = {
  label: string|React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  active?: boolean;
  unread?: boolean;
  key: string,
};


type DropdownProps = {
  actions: DropdownAction[];
  buttonLabel: string | React.ReactNode;
  className?: string;
  menuPosition?: "up" | "down";
  variant?: "default" | "chat";
};


export function Dropdown({ actions, buttonLabel, className = "", menuPosition = "up", variant = "default" }: DropdownProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);


  useEffect(() => {
    const onClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };


    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);


  return (
    <div ref={ref} className={`dropdown dropdown--${menuPosition} dropdown--${variant} ${className}`}>
      <button
        type="button"
        className="dropdown__trigger"
        onClick={() => setOpen(v => !v)}
      >
        {buttonLabel}
      </button>


      {open && (
        <div className="dropdown__menu">
          {actions.map(action => (
            <button
              key={action.key}
              type="button"
              className={`dropdown__item ${action.disabled ? "is-disabled" : ""} ${action.active ? "is-active" : ""} ${action.unread ? "is-unread" : ""}`}
              disabled={action.disabled}
              onClick={() => {
                action.onClick();
                setOpen(false);
              }}
            >
              {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
